import { BUTTON_POSITIONS, OVERLAY_POSITION_CLASSES } from "@/lib/bannerPosition";

interface ButtonPositionSelectorProps {
  value: string;
  onChange: (value: string) => void;
}

const overlayPositions = BUTTON_POSITIONS.filter((p) => p.kind === "overlay");

export default function ButtonPositionSelector({
  value,
  onChange,
}: ButtonPositionSelectorProps) {
  const isSelected = (v: string) => value === v;

  return (
    <div>
      {/* Grade visual 3x3 representando a arte do banner */}
      <div className="relative w-44 h-28 mx-auto rounded-xl overflow-hidden border border-nude bg-beige/50 mb-3">
        {/* mini imagem de fundo opcional — mantemos neutra */}
        <div className="grid grid-cols-3 grid-rows-3 w-full h-full">
          {overlayPositions.map((p) => (
            <button
              key={p.value}
              type="button"
              title={p.label}
              onClick={() => onChange(p.value)}
              className={`flex items-center justify-center transition-colors cursor-pointer ${
                isSelected(p.value)
                  ? "bg-primary/25"
                  : "hover:bg-primary/10"
              }`}
            >
              <span
                className={`w-2.5 h-2.5 rounded-full border transition-colors ${
                  isSelected(p.value)
                    ? "bg-primary border-primary"
                    : "bg-brown/25 border-brown/30"
                }`}
              />
            </button>
          ))}
        </div>
      </div>

      {/* Opções especiais: padrão e abaixo da imagem */}
      <div className="flex flex-wrap gap-2 justify-center">
        <button
          type="button"
          onClick={() => onChange("bottom")}
          className={`px-4 py-2 rounded-full font-body text-xs transition-colors cursor-pointer whitespace-nowrap ${
            isSelected("bottom")
              ? "bg-primary text-white"
              : "bg-white border border-nude text-brown hover:bg-beige"
          }`}
        >
          Padrão (rodapé da arte)
        </button>
        <button
          type="button"
          onClick={() => onChange("below")}
          className={`px-4 py-2 rounded-full font-body text-xs transition-colors cursor-pointer whitespace-nowrap ${
            isSelected("below")
              ? "bg-primary text-white"
              : "bg-white border border-nude text-brown hover:bg-beige"
          }`}
        >
          Abaixo da imagem
        </button>
      </div>

      <p className="font-body text-[11px] text-brown/40 text-center mt-2">
        Clique na posição desejada para o botão. A opção "Abaixo da imagem"
        exibe o botão fora da arte.
      </p>
    </div>
  );
}